 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"About":"About","Clients":"Clients","Contact":"Contact","Default":"Default","FooterSite":"FooterSite","HeaderSite":"HeaderSite","Home":"Home","Project":"Project","ProjectsPage":"ProjectsPage","ContactFooter":"ContactFooter","Partners":"Partners","Services":"Services","Team":"Team","ClientsList":"ClientsList","LangSwitcher":"LangSwitcher","MainLogo":"MainLogo","Expertise":"Expertise","Faq":"Faq","Landing":"Landing","Projects":"Projects","Testimonials":"Testimonials","LinkedProjects":"LinkedProjects","ProjectSection":"ProjectSection","ProjectThumb":"ProjectThumb","Testimonial":"Testimonial","HeadingBlock":"HeadingBlock","ImageBlock":"ImageBlock","QuoteBlock":"QuoteBlock","TextBlock":"TextBlock","VideoBlock":"VideoBlock"}[chunkId]||chunkId) + "." + {"About":"06cacefa","Clients":"f2089909","Contact":"19cdd75b","Default":"beb1d4a2","FooterSite":"dc070c83","HeaderSite":"9655c282","Home":"9635c011","Project":"f25f01b0","ProjectsPage":"db6f554c","ContactFooter":"1af0aec0","Partners":"357de010","Services":"e818f402","Team":"121c6899","ClientsList":"d3042a1d","LangSwitcher":"67da3d1a","MainLogo":"bf55d279","Expertise":"edd2646e","Faq":"90e5a864","Landing":"4c2274ea","Projects":"03ea6ae1","Testimonials":"0183c987","LinkedProjects":"6d8e188f","ProjectSection":"f51be497","ProjectThumb":"d418e88f","Testimonial":"f23602c1","HeadingBlock":"6ab1b18c","ImageBlock":"b926f1b7","QuoteBlock":"ab37e813","TextBlock":"062e79fe","VideoBlock":"de163819"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"About":1,"Clients":1,"Contact":1,"Default":1,"FooterSite":1,"HeaderSite":1,"Home":1,"Project":1,"ProjectsPage":1,"ContactFooter":1,"Partners":1,"Services":1,"Team":1,"ClientsList":1,"LangSwitcher":1,"MainLogo":1,"Expertise":1,"Faq":1,"Landing":1,"Projects":1,"Testimonials":1,"LinkedProjects":1,"ProjectSection":1,"ProjectThumb":1,"Testimonial":1,"HeadingBlock":1,"ImageBlock":1,"QuoteBlock":1,"TextBlock":1,"VideoBlock":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"About":"About","Clients":"Clients","Contact":"Contact","Default":"Default","FooterSite":"FooterSite","HeaderSite":"HeaderSite","Home":"Home","Project":"Project","ProjectsPage":"ProjectsPage","ContactFooter":"ContactFooter","Partners":"Partners","Services":"Services","Team":"Team","ClientsList":"ClientsList","LangSwitcher":"LangSwitcher","MainLogo":"MainLogo","Expertise":"Expertise","Faq":"Faq","Landing":"Landing","Projects":"Projects","Testimonials":"Testimonials","LinkedProjects":"LinkedProjects","ProjectSection":"ProjectSection","ProjectThumb":"ProjectThumb","Testimonial":"Testimonial","HeadingBlock":"HeadingBlock","ImageBlock":"ImageBlock","QuoteBlock":"QuoteBlock","TextBlock":"TextBlock","VideoBlock":"VideoBlock"}[chunkId]||chunkId) + "." + {"About":"232f5430","Clients":"e61cbcbe","Contact":"c07af029","Default":"b72fedd2","FooterSite":"d9001cfb","HeaderSite":"169f6269","Home":"7ee1c69e","Project":"b5952cc3","ProjectsPage":"449e42a9","ContactFooter":"26a7b776","Partners":"c06d3850","Services":"c3efaa51","Team":"a83ce8a5","ClientsList":"b93a224e","LangSwitcher":"1e13943c","MainLogo":"5f136631","Expertise":"c61d5ae9","Faq":"bc15bc95","Landing":"1e926dea","Projects":"17b3457c","Testimonials":"553b2eb2","LinkedProjects":"951d984b","ProjectSection":"95552836","ProjectThumb":"ca2cb8ac","Testimonial":"3f0fb32c","HeadingBlock":"6bb960eb","ImageBlock":"d40d8d9f","QuoteBlock":"c725a4a5","TextBlock":"2d744212","VideoBlock":"a178978d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
